import React, { createContext, useContext } from 'react';
import store from './rootStore.model';

const RootStoreContext = createContext();

export const StoreProvider = ({ children }) => (
  <RootStoreContext.Provider value={store}>{children}</RootStoreContext.Provider>
);

export const useStore = storeName => {
  const context = useContext(RootStoreContext);

  if (!context) {
    throw new Error('To use the store, the component MUST be inside a StoreProvider');
  }

  if (storeName) {
    if (context[storeName]) {
      return context[storeName];
    }
    throw new Error(`Store ${storeName} does not exist in Root Store`);
  }

  return context;
};
